module.exports = __webpack_public_path__ + "static/newmoments1-7f83a70173bda255d3cf324898cf8b6b.png";